var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendarFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(-6 -3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13044",
    "data-name": "Path 13044",
    d: "M18.833,4.077H16.5V3H15.333V4.077H10.667V3H9.5V4.077H7.167A1.128,1.128,0,0,0,6,5.154V15.923A1.128,1.128,0,0,0,7.167,17H18.833A1.128,1.128,0,0,0,20,15.923V5.154A1.128,1.128,0,0,0,18.833,4.077Zm0,11.846H7.167V8.385H18.833Zm0-8.615H7.167V5.154H9.5V6.231h1.167V5.154h4.667V6.231H16.5V5.154h2.333Z",
    transform: "translate(0)",
    fill: "#333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarFilter);
export default __webpack_public_path__ + "static/media/calendar-filter.85f89fefe31196fbcc3950c888d23bed.svg";
export { ForwardRef as ReactComponent };